const exportTypes = {
  csv: 'text/csv;charset=utf-8;',
};

/**
 * TODO: Consider a library like FileSaver.js if this is insufficient.
 * I used a simple in-house method since we only support modern browsers.
 * This method is adapted from Stack Overflow answer: https://stackoverflow.com/a/27272943
 */
export default function saveToFileSystem(
  data,
  fileName,
  { type = exportTypes.csv } = {},
) {
  const blob = new Blob([data], { type });

  // IE11
  if (navigator.msSaveBlob) {
    navigator.msSaveBlob(blob, fileName);
  } else {
    const link = document.createElement('a');
    if (link.download !== undefined) {
      // Browsers that support HTML5 download attribute
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', fileName);
      link.style = 'visibility:hidden;display:none;';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      throw new Error('Browser does not support file download');
    }
  }
}
